export default "__VITE_ASSET__COfQ8Fed__"